<template>
  <v-app-bar class="header">
    <img
      :src="require('@/assets/images/nds/nomination-logo-with-text.svg')"
    >

    <v-spacer />

    <div
      v-if="!is_forgot_password"
      class="right"
    >
      <span class="nds-text-link text">
        {{ $t('not_yet_subscribed') }}
      </span>

      <div class="buttons">
        <a
          href="https://www.nomination.fr/tester-nos-services"
          target="_blank"
        >
          <button-element
            class="demo-button"
            :text="$t('request_demo')"
          />
        </a>

        <a
          href="https://chromewebstore.google.com/detail/nomination-linkedin/lcepghnidagkelaefnhocbdlbpbfdokb"
          target="_blank"
        >
          <button-element
            color="blue-o"
            class="demo-button"
            :text="$t('download_linkedin_application')"
          />
        </a>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import ButtonElement from '../ButtonElement.vue';
export default {
  name: 'LoginHeaderElement',
  components: {
    ButtonElement,
  },
  props: {
    is_forgot_password: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';

.header {
  height: 64px;
  padding: 0px 64px;

  .right {
    align-items: center;
    display:flex;
    justify-content: flex-end;
    gap: 24px;

    .buttons {
      align-items: center;
      display: flex;
      gap: 8px;
    }

    .text {
      color: $cornflower-blue;
      font-size: 16px;
    }

    .demo-button {
      border-radius: 20px;
      padding: 8px 16px;
      font-size: 16px;
    }
  }
}
</style>

<i18n src="@/locales/common.json"></i18n>

<i18n src="@/locales/components/elements/logins/login-header-element.json"></i18n>
